import React from 'react';
import { X, Download, ZoomIn, ZoomOut } from 'lucide-react';

export const ImageViewer = ({ src, alt, onClose }) => {
  const [zoom, setZoom] = React.useState(1);

  if (!src) return null;

  const handleDownload = async () => {
    try {
      const response = await fetch(src);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = alt || 'document';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch {
      window.open(src, '_blank');
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-black flex items-center justify-center" onClick={onClose} data-testid="image-viewer-overlay">
      {/* Toolbar */}
      <div className="absolute top-4 right-4 flex items-center gap-2 z-10" onClick={(e) => e.stopPropagation()}>
        <button onClick={() => setZoom((z) => Math.max(0.5, z - 0.25))} className="p-2 bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors" title="Zoom out">
          <ZoomOut className="w-5 h-5" />
        </button>
        <span className="text-white text-sm font-medium min-w-[3rem] text-center">{Math.round(zoom * 100)}%</span>
        <button onClick={() => setZoom((z) => Math.min(3, z + 0.25))} className="p-2 bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors" title="Zoom in">
          <ZoomIn className="w-5 h-5" />
        </button>
        <button onClick={handleDownload} className="p-2 bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors" title="Download" data-testid="image-viewer-download">
          <Download className="w-5 h-5" />
        </button>
        <button onClick={onClose} className="p-2 bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors" title="Close" data-testid="image-viewer-close">
          <X className="w-5 h-5" />
        </button>
      </div>
      {/* Label */}
      {alt && <p className="absolute top-5 left-6 text-white/80 text-sm font-medium">{alt}</p>}
      {/* Image */}
      <div className="max-w-[90vw] max-h-[85vh] overflow-auto" onClick={(e) => e.stopPropagation()}>
        <img
          src={src}
          alt={alt}
          style={{ transform: `scale(${zoom})`, transformOrigin: 'center center', transition: 'transform 0.2s' }}
          className="max-w-full max-h-[85vh] object-contain rounded"
          data-testid="image-viewer-img"
        />
      </div>
    </div>
  );
};
